module.exports = __webpack_public_path__ + "img/0Q3A5767_L_Wood.888a72ef.jpg";